import { getBaseUnitFactor } from '../cart/response/OrderProductListGrouped';

export type MinQuantity = {
    minQuantity: number;
    colli: string;
};

// a piece unit has no gram factor (0) — it sorts by its own quantity instead of collapsing to 0
const sortFactor = (colli: string): number => getBaseUnitFactor(colli) || 1;

export function sortMinQuantity(a: MinQuantity, b: MinQuantity): number {
    return sortFactor(a.colli) * a.minQuantity - sortFactor(b.colli) * b.minQuantity;
}

export type DiscountEntry = MinQuantity & {
    value: number;
    premiumLevel: number;
};

export class PremiumLevelDiscounts {
    public get orderedDiscountEntries(): DiscountEntry[] {
        return Array.from(this.minQuantityMap.values()).sort(sortMinQuantity);
    }

    public get maxDiscountEntry(): DiscountEntry | undefined {
        const ordered = this.orderedDiscountEntries;

        if (ordered.length > 0) return ordered[ordered.length - 1];

        return undefined;
    }

    public readonly premiumLevel: number;

    constructor(json: any) {
        this.premiumLevel = json.premiumLevel;

        this.minQuantityMap = new Map();

        for (const { minQuantity, colli, discountInPercent } of json.discounts) {
            this.minQuantityMap.set(minQuantity, {
                minQuantity,
                colli,
                value: discountInPercent / 100,
                premiumLevel: this.premiumLevel,
            });
        }
    }
    private readonly minQuantityMap: Map<number, DiscountEntry>;

    public getDiscount(minQuantity: number): DiscountEntry | undefined {
        return this.minQuantityMap.get(minQuantity);
    }
}
